import React from 'react'

const HeaderText = ({ title }: { title: string }) => <>{title}</>

export default HeaderText
